






import { Component, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
@Component({
  components: {
  },
})
export default class WebsiteHomepage extends AbpBase {

}
